// src/pages/users/tabs/OrdersTab.jsx
import React from 'react';

export default function OrdersTab() {
  return (
    <div className="bg-[#1b2433] rounded-2xl shadow-lg p-6">
      <h3 className="text-white font-semibold mb-4">My Orders</h3>
      <p className="text-gray-300">No orders to display.</p>
    </div>
  );
}
